export const enum ChargePointStatus {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
  FAULTED = 'faulted'
}
